var _path, _path2, _rect, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 293,
    viewBox: "0 0 206 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.648 160.855V292.587H1.11914V160.991L113.661 160.916L204.648 160.855Z",
    fill: "#DDDDE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.647 160.855V292.587H113.661V160.916L204.647 160.855Z",
    fill: "#BABACC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.619141,
    y: 0.846191,
    width: 204.53,
    height: 291.74,
    fill: "url(#paint0_linear_89_30998)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.041 171.629L124.369 212.409C118.414 215.618 111.295 215.863 105.134 213.066L5.56067 167.884C2.85866 166.656 1.11914 163.964 1.11914 160.996C1.11914 158.269 2.58294 155.757 4.9541 154.414L87.343 107.723L197.935 151.526C202.286 153.251 205.149 157.457 205.149 162.139V163.081C205.149 166.656 203.189 169.939 200.041 171.634V171.629Z",
    fill: "#C4C4D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.54 161.602L123.868 202.383C117.913 205.591 110.794 205.837 104.633 203.04L5.0597 157.857C2.35768 156.629 0.618164 153.937 0.618164 150.97C0.618164 148.243 2.08196 145.731 4.45312 144.388L86.842 97.6963L197.434 141.5C201.785 143.224 204.648 147.43 204.648 152.113V153.055C204.648 156.629 202.688 159.913 199.54 161.607V161.602Z",
    fill: "#DDDDE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.586 194.949C111.917 194.949 110.298 194.598 108.774 193.906L8.58887 147.716L85.6038 103.767L91.6044 102.955L194.873 144.062C194.913 144.077 197.274 145.721 197.88 147.571C197.885 147.586 197.89 147.601 197.895 147.621C198.412 149.22 197.68 150.96 196.201 151.762L119.111 193.555C117.416 194.468 115.506 194.949 113.586 194.949Z",
    fill: "#F9F9FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_30998",
    x1: 102.884,
    y1: 0.846191,
    x2: 102.884,
    y2: 288.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.606472,
    stopColor: "#F6F7F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967716,
    stopColor: "#F6F7F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStand);
export default __webpack_public_path__ + "static/media/STAND.5bf3c709c94a99f1cf7a1afb2da81179.svg";
export { ForwardRef as ReactComponent };